var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.104 3.771a.5.5 0 010 .708l-3.667 3.666a.5.5 0 01-.178.115L6.694 9.597l-.945.945 5.71 5.71.944-.946 1.337-3.565a.502.502 0 01.115-.178l3.666-3.667a.5.5 0 11.707.708l-3.59 3.59-1.336 3.565a.5.5 0 01-.115.178l-1.375 1.375a.5.5 0 01-.707 0l-6.417-6.417a.5.5 0 010-.707l1.375-1.375a.5.5 0 01.178-.114l3.565-1.337 3.59-3.59a.5.5 0 01.707 0z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.604 13.396a.5.5 0 010 .708l-4.125 4.125a.5.5 0 01-.708-.708l4.125-4.125a.5.5 0 01.708 0zM12.938 3.313a.5.5 0 01.707 0l5.042 5.042a.5.5 0 11-.707.707L12.938 4.02a.5.5 0 010-.707z",
    fill: "#2C3E50"
  })));
}
export default SvgPin;